import styled from "styled-components";
import { colors, FilterChip, typography } from "@streeteasy/design-system";

const { TEXT_SECONDARY } = colors;
const { Caps } = typography;

export const LocationChip = styled(FilterChip)`
  line-height: 22px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-top: 4px;
`;

export const LocationsLabel = styled(Caps).attrs({
  as: "h6"
})`
  color: ${TEXT_SECONDARY};
  display: block;
  margin-bottom: 16px;
`;

export const List = styled.ul`
  outline: none;
  padding: 0;
`;

export const ListItem = styled.li`
  display: inline-block;
`;
